<template>
  <div style="font-size: 16px !important;">
    <!-- <pre >{{ selectedActivity }}</pre> -->
    <v-card v-if="Object.keys(selectedActivity).length != 0" outlined class="pa-4 mt-5 mb-4">
      <!-- Header -->
      <v-row align="center">
        <v-col cols="9">
          <h3 class="mb-1 font-weight-bold v-head-font">
            {{ selectedActivity.name_academic }}
          </h3>
          <small class="grey--text">
            {{ selectedActivity.activity_type_detail.detail }}
            ({{ selectedActivity.activity_type_detail.point }} Point / hour)
          </small>
        </v-col>

        <v-col cols="3" class="text-right">
          <v-chip small label :color="selectedActivity.status === 'approve' ? 'green' : 'orange'" class="white--text">
            {{ selectedActivity.status.toUpperCase() }}
          </v-chip>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>

      <!-- Detail -->
      <v-row>
        <v-col cols="6">
          <!-- <div><strong>Year:</strong> {{ selectedActivity.year_academic }}</div> -->
          <div>
            <strong>Date:</strong>
            {{ selectedActivity.date_start }} → {{ selectedActivity.date_end }}
          </div>
          <div><strong>Sector:</strong> {{ selectedActivity.sector }}</div>
        </v-col>

        <v-col cols="6">
          <div><strong>Organizer:</strong> {{ selectedActivity.organizer_record }}</div>
          <div><strong>Hours:</strong> {{ selectedActivity.point_activity }}</div>
          <div><strong>Total Point:</strong> {{ selectedActivity.point_activity }}</div>
        </v-col>
      </v-row>

      <!-- Files -->
      <v-divider class="my-3"></v-divider>

      <div>
        
        <strong>Attachments</strong>
        <v-list dense v-if="selectedActivity.files && selectedActivity.files.length">
          <v-list-item v-for="file in selectedActivity.files" :key="file.id" :href="file.file" target="_blank">
            <v-list-item-icon>
              <v-icon color="red">mdi-file-pdf-box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="v-nav-font">
                {{ decodeURIComponent(file.file.split('/').pop()) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <p v-else class="grey--text mb-0">
          No attachments
        </p>

      </div>

      <!-- ===== Action Buttons ===== -->
      <v-divider class="my-3"></v-divider>

      <v-row class="mt-3 mb-2 pa-3" justify="end">

        <v-btn
          v-if="['approve', 'reject'].includes(selectedActivity.status)"
          color="yellow darken-2"
          class="mr-2"
          @click="undoActivity"
        >
          <v-icon left>mdi-arrow-u-left-top</v-icon>
          Undo
        </v-btn>

        <v-btn
          color="red darken-2"
          outlined
          class="mr-2"
          :disabled="isFinalStatus"
          @click="openRejectDialog"
        >
          <v-icon left>mdi-close-circle</v-icon>
          Reject
        </v-btn>

        <v-btn
          color="green darken-1"
          class="white--text"
          :disabled="isFinalStatus"
          @click="approveActivity"
        >
          <v-icon left>mdi-check-circle</v-icon>
          Approve
        </v-btn>
      </v-row>

      <!-- ===== Reject Dialog ===== -->
      <v-dialog v-model="rejectDialog" max-width="500">
        <v-card>
          <v-card-title class="font-weight-bold">
            Reject Activity
          </v-card-title>

          <v-card-text>
            <v-textarea
              v-model="rejectRemark"
              label="Reason for rejection"
              outlined
              rows="3"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="rejectDialog = false">Cancel</v-btn>
            <v-btn
              color="red darken-2"
              class="white--text"
              @click="rejectActivity"
            >
              Confirm Reject
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SheetData',
  props: {
    selectedActivity: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rejectDialog: false,
      rejectRemark: ''
    }
  },
  computed: {
    isFinalStatus() {
      return ['approve', 'reject'].includes(this.selectedActivity.status)
    },
    statusColor() {
      if (this.selectedActivity.status === 'approve') return 'green'
      if (this.selectedActivity.status === 'reject') return 'red'
      return 'orange'
    }
  },
  methods: {
    approveActivity() {
      this.$emit('approve', { data: this.selectedActivity, textStatus: 'approve' })
    },
    undoActivity() {
      this.$emit('undo', { data: this.selectedActivity, textStatus: 'send' })
    },
    openRejectDialog() {
      this.rejectDialog = true
    },
    rejectActivity() {
      this.$emit('reject', {
        data: this.selectedActivity,
        textStatus: 'reject',
        comment: this.rejectRemark
      })
      this.rejectDialog = false
      this.rejectRemark = ''
    }
  }
}
</script>
